module.exports = __webpack_public_path__ + "static/2-06a7509faeaeb7821908d29124216a94.png";